import React, { useMemo } from "react";
import {
    FaCheckCircle,
    FaExclamationTriangle,
    FaBalanceScale,
    FaUniversity
} from "react-icons/fa";


function BankCrossCheck({ bankData = [] }) {


    // =========================================================
    // FORMAT NUMBER
    // =========================================================

    const formatNumber = (value) => {

        return Number(value || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

    };


    // =========================================================
    // CALCULATE TOTALS
    // =========================================================

    const totals = useMemo(() => {

        let ledgerUsd = 0;
        let creditUsd = 0;

        let ledgerBrl = 0;
        let creditBrl = 0;

        let debitBrl = 0;


        bankData.forEach((bank) => {
		console.log('cross check');
		console.log(bank.credit_usd);
            ledgerUsd +=
                Number(bank.credit_usd) || 0;

            creditUsd +=
                Number(bank.credit_usd) || 0;


            ledgerBrl +=
                Number(bank.credit_brl) || 0;

            creditBrl +=
                Number(bank.credit_brl) || 0;


            debitBrl +=
                Number(bank.debit_brl) || 0;

        });


        return {

            ledgerUsd,
            creditUsd,

            ledgerBrl,
            creditBrl,

            debitBrl

        };

    }, [bankData]);


    // =========================================================
    // CROSS CHECK ROWS
    // =========================================================

    const crossCheckRows = [

        {
            description: "Credit USDT",

            ledgerLabel:
                "Total of Column: 4",

            ledgerAmount:
                totals.ledgerUsd,

            bankLabel:
                "Total of Bank Summary Credit USD Column (C)",

            bankAmount:
                totals.creditUsd,

            difference:
                totals.ledgerUsd -
                totals.creditUsd,

            currency: "USD"

        },

        {
            description: "Credit BRL",

            ledgerLabel:
                "Total of Column: 5",

            ledgerAmount:
                totals.ledgerBrl,

            bankLabel:
                "Total of Bank Summary Credit BRL Column (D)",

            bankAmount:
                totals.creditBrl,

            difference:
                totals.ledgerBrl -
                totals.creditBrl,

            currency: "BRL"

        },

        {
            description: "Debit BRL",

            ledgerLabel:
                "Total of Column: 6",

            ledgerAmount:
                totals.debitBrl,

            bankLabel:
                "Total of Bank Summary Debit BRL Column (E)",

            bankAmount:
                totals.debitBrl,

            difference:
                0,

            currency: "BRL"

        }

    ];


    // =========================================================
    // STATUS
    // =========================================================

    const getStatus = (difference) => {

        const value =
            Number(difference) || 0;


        if (Math.abs(value) < 0.01) {

            return {

                text: "Matched",

                className:
                    "text-success",

                icon:
                    <FaCheckCircle />

            };

        }


        return {

            text: "Mismatch",

            className:
                "text-danger",

            icon:
                <FaExclamationTriangle />

        };

    };


    // =========================================================
    // NO DATA
    // =========================================================

    if (!bankData.length) {

        return (

            <div className="card shadow-sm border-0">

                <div className="card-body text-center py-5">

                    <FaUniversity
                        size={35}
                        className="text-muted mb-3"
                    />

                    <h5 className="text-muted">
                        No Bank Data Available
                    </h5>

                    <p className="text-muted mb-0">
                        Bank information will appear
                        here after the Bank API is loaded.
                    </p>

                </div>

            </div>

        );

    }


    // =========================================================
    // UI
    // =========================================================

    return (

        <div className="card shadow-sm border-0 mb-4">


            {/* HEADER */}

            <div className="card-header bg-white">

                <div className="d-flex align-items-center">

                    <FaBalanceScale
                        className="me-2"
                    />

                    <div>

                        <h5 className="mb-0 fw-bold">
                            Bank Cross Check
                        </h5>

                        <small className="text-muted">
                            Ledger vs Bank Statement Summary
                        </small>

                    </div>

                </div>

            </div>


            {/* TABLE */}

            <div className="table-responsive">

                <table className="table table-bordered table-hover align-middle mb-0">


                    <thead className="table-light">

                        <tr>

                            <th>
                                Description
                            </th>

                            <th>
                                Ledger Description
                            </th>

                            <th className="text-end">
                                Ledger Total
                            </th>

                            <th>
                                Bank Summary Description
                            </th>

                            <th className="text-end">
                                Bank Total
                            </th>

                            <th
                                className="text-end"
                                style={{ width: "120px" }}
                            >
                                Difference
                            </th>

                            <th
                                className="text-center"
                                style={{ width: "120px" }}
                            >
                                Status
                            </th>

                        </tr>

                    </thead>


                    <tbody>

                        {crossCheckRows.map(
                            (row, index) => {

                                const status =
                                    getStatus(
                                        row.difference
                                    );


                                return (

                                    <tr
                                        key={index}
                                    >

                                        {/* DESCRIPTION */}

                                        <td>

                                            <strong>
                                                {row.description}
                                            </strong>

                                        </td>


                                        {/* LEDGER DESCRIPTION */}

                                        <td>
                                            {row.ledgerLabel}
                                        </td>


                                        {/* LEDGER TOTAL */}

                                        <td className="text-end fw-semibold">

                                            {row.currency === "USD"
                                                ? "$"
                                                : "R$"
                                            }

                                            {" "}

                                            {formatNumber(
                                                row.ledgerAmount
                                            )}

                                        </td>


                                        {/* BANK DESCRIPTION */}

                                        <td>
                                            {row.bankLabel}
                                        </td>


                                        {/* BANK TOTAL */}

                                        <td className="text-end fw-semibold">

                                            {row.currency === "USD"
                                                ? "$"
                                                : "R$"
                                            }

                                            {" "}

                                            {formatNumber(
                                                row.bankAmount
                                            )}

                                        </td>


                                        {/* DIFFERENCE */}

                                        <td
                                            className={`text-end fw-bold ${status.className}`}
                                        >

                                            {row.currency === "USD"
                                                ? "$"
                                                : "R$"
                                            }

                                            {" "}

                                            {formatNumber(
                                                row.difference
                                            )}

                                        </td>


                                        {/* STATUS */}

                                        <td
                                            className={`text-center fw-semibold ${status.className}`}
                                        >
                                            {status.icon}

                                            <span className="ms-1">
                                                {status.text}
                                            </span>

                                        </td>

                                    </tr>

                                );

                            }
                        )}

                    </tbody>

                </table>

            </div>

        </div>

    );

}


export default BankCrossCheck;
